<script>
    import MobileNavbar from '../reusableitems/mobileNavbar.svelte';
    import {pageName} from '../store';
    const url = '/'+$pageName;
    $: console.log('url', url);
</script>

<section>
    <div class = 'navbar'>
        <MobileNavbar />
    </div>

    <div class="main-div">
        <div class="wrapper">
            <div class="video-div">
                <video width="100%" height="100%" controls autoplay loop muted>
                    <source src="https://static.opus.ai/demo.mp4" type="video/mp4" />
                </video>
            </div>
        </div>
        

            <div class="btn" role="presentation"
            on:click={()=>{
                location.href = url;
            }}
            >
                <button> Close </button>
            </div>
        
    </div>
</section>

<style>
    .navbar{
        width: 100%;
        position: fixed;
        z-index: 10;
    }
    .main-div {
        background-color: black;
        width: 100%;
        font-family: "Orbitron";
        height: 100%;
        position: fixed;
    }
    .video-div video {
        width: 89.953vw;
        position: absolute;
        height: 53.037vw;
        top: 0;
        bottom: 0;
        margin: auto;
        left: 0;
        right: 0;
    
    }

    .btn {
        bottom: 0vw;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        left: 46.262vw;
    }

    button {
        background-color: black;
        border: none;
        color: white;
        font-family: "Orbitron";
        font-size: 2.57vw;
        font-weight: 700;
        line-height: 3.222vw;
        margin-bottom: 5.91vw;
    }
</style>
